/**
 * After any platform-panel change, mark every platform query stale.
 *
 * The panel's data is interlinked — reactivating a company on its detail page
 * changes the Companies list and the Dashboard counts, a new plan name shows
 * in the list, deleting a user changes the company's user count — and the app
 * keeps query results fresh for 24 h, so refreshing only the page's own query
 * left the other pages showing stale rows. Open queries refetch at once, the
 * rest the next time their page mounts. (Query keys all start "platform-".)
 */
// Keys are either arrays (['platform-companies', page, …]) or plain strings
// ('platform-plans', 'platform-dashboard') — for a string, queryKey[0] would
// be just its first letter.
const keyName = (queryKey) => String(Array.isArray(queryKey) ? queryKey[0] : queryKey)

const refreshPlatform = (queryClient) =>
    queryClient.invalidateQueries({ predicate: (query) => keyName(query.queryKey).startsWith('platform-') })

export default refreshPlatform
